import { createFileRoute, redirect } from '@tanstack/react-router'
import { createPrismSearch } from 'routes/prism/-searchParams'
import { Route as NewRoute } from 'routes/prism/index'

export const Route = createFileRoute(
  '/prism/(deprecated_routes)/$orgID/$entryId'
)({
  beforeLoad: ({ params }) => {
    const { orgID, entryId } = params

    throw redirect({
      to: NewRoute.to,
      search: createPrismSearch({
        entryId,
        orgId: orgID,
        siteId: undefined,
      }),
      replace: true,
    })
  },
})
